import React, { useState, useEffect } from 'react';
import './InfoUserMain.css';
import { API_ENDPOINTS } from '../../../config/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faMoneyBill } from '@fortawesome/free-solid-svg-icons';

export default function InfoUserMain() {
    const [totalCobrado, setTotalCobrado] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(API_ENDPOINTS.turnos, { 
            method: 'GET', 
            credentials: 'include' 
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                const turnos = data.turnos || [];
                const total = turnos
                    .filter(turno => turno.estado === 'Finalizado')
                    .reduce((acc, turno) => {
                        const pago = parseFloat(turno.pago) || 0;
                        return acc + pago;
                    }, 0);
                setTotalCobrado(total);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            });
    }, []);

    const formatMoney = (amount) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        }).format(amount);
    };

    return (
        <div className='infoUser'>
            {loading ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>Cargando...</div>
            ) : (
                <>
                    <FontAwesomeIcon icon={faMoneyBill} className='icons' style={{ fontSize: '48px', color: 'var(--success, #28a745)', marginBottom: '10px' }} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h3 style={{ margin: 0, fontSize: '16px', color: 'var(--text-secondary, #666)' }}>Balance Total</h3>
                        <h2 style={{ margin: 0, fontSize: '32px', fontWeight: 'bold', color: 'var(--success, #28a745)' }}>
                            {formatMoney(totalCobrado)}
                        </h2>
                        <span style={{ fontSize: '14px', color: 'var(--text-secondary, #999)' }}>
                            Total cobrado en citas
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}
